import _ from 'lodash';
import { ANNOTATION_TYPE } from '../../../config';

type AFibEventInstance = {
  type: any;
  canvasChart: any;
  ctxChart: any;
  config: any;
  displayedChannelsArr: any;
  pixelSamples: any;
  channelIndex: any;
  startSample: any;
  endSample: any;
  color: any;
};

let AFibEvent;

(function () {
  AFibEvent = function (
    this: AFibEventInstance,
    canvasChart: any,
    config: any,
    displayedChannelsArr: any,
    pixelSamples: any,
    afibEvent: any,
  ) {
    this.type = ANNOTATION_TYPE.AFIB_EVENT;
    this.canvasChart = canvasChart;
    this.ctxChart = this.canvasChart.getContext('2d');
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
    this.pixelSamples = pixelSamples;
    this.channelIndex = afibEvent.channelIndex;
    this.startSample = afibEvent.startSample;
    this.endSample = afibEvent.endSample;
    this.color = 'red';
  };

  AFibEvent.prototype.drawOneAFibEvent = function (
    this: AFibEventInstance,
    offsetX: any,
    strokeStyle = this.color,
  ) {
    this.ctxChart.beginPath();
    this.ctxChart.strokeWidth = 1.5;
    this.ctxChart.strokeStyle = strokeStyle;
    _.forEach(this.displayedChannelsArr, (element, index) => {
      if (this.channelIndex === element) {
        for (let j = this.startSample; j < this.endSample; j += 1) {
          this.ctxChart.moveTo(
            this.pixelSamples[index][j].x - this.pixelSamples[index][offsetX].x,
            this.pixelSamples[index][j].y,
          );
          this.ctxChart.lineTo(
            this.pixelSamples[index][j + 1].x - this.pixelSamples[index][offsetX].x,
            this.pixelSamples[index][j + 1].y,
          );
        }
      }
      this.ctxChart.stroke();
      this.ctxChart.closePath();
    });
  };

  AFibEvent.prototype.update = function (
    this: AFibEventInstance,
    pixelSamples: any,
    config: any,
    displayedChannelsArr: any,
  ) {
    this.pixelSamples = pixelSamples;
    this.config = config;
    this.displayedChannelsArr = displayedChannelsArr;
  };

  AFibEvent.prototype.getJSONObject = function (this: AFibEventInstance) {
    return {
      type: this.type,
      channelIndex: this.channelIndex,
      startSample: this.startSample,
      endSample: this.endSample,
    };
  };
})();

export { AFibEvent };
export default { AFibEvent };
